import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useFetch, useForm, useGrid, useStore, useToast } from "@/comn/hooks";
import { APIS, SF_FAQ_MGMT_SRCH, SG_FAQ_MGMT_LIST, URLS } from "@/tra/tancis/ptli/cmnty/qna/services/PtliQnaService";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { usePopup } from "@/comn/hooks";

/*
 * Role Management List
 * !== 역할 관리 목록 ==!
 */
export const PTLI0310001Q = (): JSX.Element => {
    const pgeUid = "UI-PTLI-0313-001Q";
    const { t } = useTranslation();
    const navigate = useNavigate();
    const toast = useToast();
    const { openPopup } = usePopup();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });

    const form = {
        qnaList: useForm({
            defaultSchema: SF_FAQ_MGMT_SRCH,
            defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    const grid = {
        qnaList: useGrid({
            defaultSchema: SG_FAQ_MGMT_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getQnaList: useFetch({
            api: (page = grid.qnaList.page) => APIS.getQnaList(form.qnaList.getValues(), page, grid.qnaList.size),
            enabled: comnUtils.isEmpty(form.qnaList.errors),
            key: [grid.qnaList.page, grid.qnaList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.qnaList.getValues(),
                    page: grid.qnaList.page,
                    size: grid.qnaList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const render = {
        cell: {
            boardTitle: (props: any) => {
                const { rowValues, value } = props;
                console.log(rowValues.boardId);
                return <Link to={`/ptli/cmnty/qna/ptli0310001s/${rowValues.boardId}`}>{value}</Link>;
            },
        },
    };

    const handler = {
        onSrchBtnClick: () => {
            grid.qnaList.setPage(0);
            fetch.getQnaList.fetch(0);
        },
        //onNewBtnClick: () => navigate(URLS.ptli0313001s),
    };

    useEffect(() => {
        handler.onSrchBtnClick();
    }, []);

    return (
        <Page
            id={pgeUid}
            title={t("T_FAQ")}
            navigation={{
                base: comnEnvs.base,
                nodes: [
                    { label: "Portal" },
                    { label: "Internal Portal Management" },
                    { label: "My Page" },
                    { path: "/iptm/mypg/ptli0313001q", label: "FAQ" },
                ],
            }}
        >
            <Group>
                <Group.Section>
                    <Group.Row>
                        <Group.Control {...form.qnaList.schema.frstRgsrDtmRnge} />
                        <Group.Control
                            {...form.qnaList.schema.faq}
                            rightButton={{
                                icon: "search",
                                onClick: () => {
                                    openPopup({
                                        url: `${comnEnvs.base_comn}/comn/ppup/orgCdPpup`,
                                        callback: ({ data }) => {
                                            form.qnaList.setValues(
                                                {
                                                    exppnCd: data.orgCd,
                                                    exppnNm: data.orgNm,
                                                    exppnTelno: data.rprsTelno,
                                                    exppnAddr: data.physAddr,
                                                },
                                                true,
                                            );
                                        },
                                    });
                                },
                            }}
                        />
                    </Group.Row>
                    <Group.Row>
                        <Group.Control {...form.qnaList.schema.sysCat} />
                        <Group.Control {...form.qnaList.schema.boardTitle} />
                    </Group.Row>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.qnaList.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            {/* <Button role={"new"} onClick={handler.onNewBtnClick} /> */}
                            <Button role={"search"} onClick={handler.onSrchBtnClick} />
                        </Layout.Right>
                    </Layout>
                </Group.Section>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.qnaList.grid} data={fetch.getQnaList.data?.qnaList} render={render} />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
